import {ProductBase} from 'new-models';

export const useIsProductAvailable = (product?: ProductBase): boolean => {
    return Boolean(product && product.availability && product.availabilityCount);
};
